import {
	CORE_Christmas_Club_Thumbnail,
	CORE_Clinic_Card_Thumbnail,
	CORE_GLI_Thumbnail,
	CORE_GLTD_CLASS_1_Thumbnail,
	CORE_GLTD_CLASS_2_Thumbnail,
	CORE_GSTD_Thumbnail,
	CORE_Health_Plan_Benefit_Thumbnail,
	CORE_Helping_Our_Own_Thumbnail,
	VEB_Cancer,
	VEB_Whole_Life,
	CORE_KSOP_Thumbnail,
	VEB_STD,
	VEB_Hospital,
	VEB_Accient,
	VEB_Limited_indemnity,
	VEB_GROUP_LIMITED_INDEMNITY,
	VEB_Term_Life,
	VEB_DOC_N_RX,
	VEB_Vision,
	VEB_Dental,
	VEB_Critical_Illness,
	PFBDentalPlanImage,
	PFBVisionPlanImage
} from "../assets";

export const COREBenefitThumbnailMap = {
	"Health Plan": CORE_Health_Plan_Benefit_Thumbnail,
	"Clinic Card": CORE_Clinic_Card_Thumbnail,
	"Group Short Term Disability": CORE_GSTD_Thumbnail,
	"Group Long Term Disability(Class 1)": CORE_GLTD_CLASS_1_Thumbnail,
	"Group Long Term Disability(Class 2)": CORE_GLTD_CLASS_2_Thumbnail,
	"Helping Our Own": CORE_Helping_Our_Own_Thumbnail,
	KSOP: CORE_KSOP_Thumbnail,
	"Christmas Club Election": CORE_Christmas_Club_Thumbnail,
	"Group Life Insurance": CORE_GLI_Thumbnail
};

export const COREPFBBenefitThumbnailMap = {
	"Health Plan": CORE_Health_Plan_Benefit_Thumbnail,
	"Dental Plan": PFBDentalPlanImage,
	"Vision Plan": PFBVisionPlanImage
};

export const VEBBenefitThumbnailMap = {
	Cancer: VEB_Cancer,
	"Whole life": VEB_Whole_Life,
	"Child Term": VEB_Whole_Life,
	"Short Term Disability": VEB_STD,
	"Hospital Indemnity": VEB_Hospital,
	Accident: VEB_Accient,
	"Group Life Indemnity": VEB_Limited_indemnity,
	"Group Limited Indemnity": VEB_GROUP_LIMITED_INDEMNITY,
	"Family Protection": VEB_Term_Life,
	"Doc and Rx": VEB_DOC_N_RX,
	Vision: VEB_Vision,
	Dental: VEB_Dental,
	"Critical Illness": VEB_Critical_Illness
};
